<ngb-datepicker [(ngModel)]="model"></ngb-datepicker>